import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import CustomText from 'components/text/CustomText'
import CustomModal from 'components/modals/CustomModal'
import Avatar, { AvatarSize } from 'components/avatar/Avatar'
import { TITLES } from 'locales/locales'
import { FixMeLater } from 'types'

interface IOtrOfflineUsersProps {
  users: {
    fullname: string
    avatar: string
    _id: string
  }[]
  onClose: () => void
}

const OtrOfflineUserList = ({ users, onClose }: IOtrOfflineUsersProps) => {
  const { t } = useTranslation()
  return (
    <CustomModal
      showButtons={false}
      size="medium"
      closeModal={onClose}
      title={t(TITLES.OTR_OFFLINE_USERS)}
    >
      <ReactionList>
        {users?.map((user: FixMeLater) => (
          <ReactionPeopleWrapper key={user._id}>
            <Avatar source={user?.avatar} text={user.fullname} size={AvatarSize.average} />
            <CustomText typography="header3">{user.fullname}</CustomText>
          </ReactionPeopleWrapper>
        ))}
      </ReactionList>
    </CustomModal>
  )
}

export default OtrOfflineUserList

const ReactionList = styled.div`
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  row-gap: 10px;
`

const ReactionPeopleWrapper = styled.div`
  display: flex;
  column-gap: 10px;
  align-items: center;
`